import { useEffect } from 'react'
import { onAuthChange } from '@fleetops/firebase'
import { useAuthStore } from '@/store/auth.store'

interface AuthProviderProps {
  children: React.ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { setSession, setInitialized } = useAuthStore()

  useEffect(() => {
    const unsubscribe = onAuthChange((session) => {
      setSession(session)
      setInitialized()
    })
    return unsubscribe
  }, [setSession, setInitialized])

  return <>{children}</>
}
